module.exports = __webpack_public_path__ + "fonts/moderno_1bdbf037edc31f53185bbb413bcd592a.ttf";